<template>
    <div v-if="SidebarStore" class="sidebar-search-flex-component">
        <div v-if="SidebarStore.menu === 'obras'" class="row" id="sidebar-opcao-obras">
            <div v-if="SidebarStore.open" class="d-flex bd-highlight altura-area-menu-info">
                <div class="p-1 flex-grow-1 bd-highlight sidebar-search-flex-geo text-center"
                    :class="SidebarStore.open ? 'active-sidebar' : ''">
                    <div class="tamanho-icone-menu-info">
                        <i class="bi bi-geo-alt-fill"></i>
                        <span>{{ quantidadeLocalizacoes }}</span>
                    </div>
                </div>
                <div class="p-1 flex-grow-1 bd-highlight sidebar-search-flex-work text-center"
                    :class="SidebarStore.open ? 'active-sidebar' : ''">
                    <div class="tamanho-icone-menu-info">
                        <obra-icon class="sidebar-icon-obra" />
                        <span>{{ quantidadeObras }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="SidebarStore.menu === 'notificacoes'" class="row" id="sidebar-opcao-notificacoes">
            <div v-if="SidebarStore.open" class="d-flex bd-highlight altura-area-menu-info">
                <div class="p-1 flex-grow-1 bd-highlight sidebar-search-flex-work text-center"
                    :class="SidebarStore.open ? 'active-sidebar' : ''">
                    <div>
                        <span class="titulo">{{ SidebarStore.titulo }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!SidebarStore.open" class="row" id="sidebar-opcao-vazio">
            <div class="d-flex bd-highlight altura-area-menu-info">
                <div class="p-1 bd-highlight sidebar-search-flex-empty " :class="listagemAtiva ? 'laranja' : ''">
                    <div class="sidebar-icon-empty">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { mapStores } from 'pinia';
import { defineComponent } from 'vue';
import ObraIcon from "@/components/icons/ObraIcon.vue";
import { useObraStore } from '@/stores/obras';
import { useSidebarStore } from '@/stores/sidebar';

export default defineComponent({
    components: {
        ObraIcon
    },
    props: {
        listagemAtiva: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapStores(useObraStore),
        ...mapStores(useSidebarStore),
        quantidadeLocalizacoes() {
            return !this.ObraStore.listarObrasSelecionadas
                ? this.ObraStore.localizacoesFiltradas.length
                : this.ObraStore.quantidadeLocalizacoesSelecionadas;
        },
        quantidadeObras() {
            return !this.ObraStore.listarObrasSelecionadas
                ? this.ObraStore.obrasFiltradas.length
                : this.ObraStore.obrasSelecionadasFiltradas.length;
        },
    },
})

</script>

<style scoped>
.altura-area-menu-info {
    height: 38px;
}

.tamanho-icone-menu-info>svg {
    height: 27px;
}

.tamanho-icone-menu-info>i {
    font-size: 20px;
}

.tamanho-icone-menu-info>span {
    font-size: 20px;
    margin-left: 10px;
}

span.titulo {
    color: #ffffff;
    font-size: 20px;
    font-weight: bold;
}

.laranja {
    background-color: #f58634;
}
</style>